<template>
  <CContainer>
    <ValidationObserver ref="fieldForm" v-slot="{ invalid, handleSubmit }">
      <Form @submit.prevent="handleSubmit(submit)">
        <CRow class="position-sticky" style="top: 50px;z-index: 999;">
          <CCol col="12" class="my-2 ml-2 white-bg py-2 shadow-sm d-flex">
            <Message class="w-fit-content my-auto" />
            <CButton
              :disabled="invalid || showLoading"
              type="submit"
              color="primary"
              class="mr-auto px-4"
              >{{ $t("submit") }}</CButton
            >
          </CCol>
        </CRow>

        <CRow class="position-relative">
          <Loading />

          <CCol col="12" sm="5" md="4" class="white-bg order-md-last py-3 mb-1 mb-sm-0">
            <CRow>
              <CCustomInputCheckbox
                v-model="landingPage.status"
                sm="12"
                vid="status"
                :name="$t('store.landing_page.status')"
              />

              <CCustomInputCheckbox
                v-model="landingPage.indexable"
                sm="12"
                vid="indexable"
                :name="$t('store.landing_page.indexable')"
              />

              <CCol col="12">
                <div class="my-2 w-100 b-b-1"></div>
              </CCol>

              <CCustomInput
                v-model="landingPage.slug"
                sm="12"
                vid="slug"
                :name="$t('store.landing_page.slug')"
                rules="required"
                required
              />

              <CCustomInput
                v-model="landingPage.content.category"
                sm="12"
                vid="category"
                :name="$t('store.landing_page.category')"
                rules="required"
                required
              />

              <CCustomImageInputFile
                sm="12"
                vid="featured_image"
                :name="$t('store.landing_page.featured_image')"
                v-model="landingPage.content.featured_image"
                showImagePreview
                path="landing_pages"
                :rules="{
                  required: landingPage.content.featured_image ? false : true,
                  image: true,
                  ext: ['jpeg', 'jpg', 'png'],
                }"
                required
              />

              <CCustomImageInputFile
                sm="12"
                vid="video"
                :name="$t('store.landing_page.video')"
                v-model="landingPage.content.video"
                path="landing_pages"
                :rules="{ required: false, ext: ['mp4'] }"
              />
            </CRow>

            <CRow class="mt-4">
              <CCustomSearchableInput
                col="12"
                vid="id"
                name="محصولات منتخب"
                v-model="productId"
                :items="products"
                itemValue="name"
                :resultListMaxHeight="100"
              >
                <template #append>
                  <div class="bg-primary d-flex mfs-1 cursor-pointer" :style="{ opacity: productItem && productItem.id ? '1' : '0.65'}"  @click="addProduct">
                    <FaIcon icon="check" class="my-auto mx-3" />
                  </div>
                </template>
              </CCustomSearchableInput>

              <CCol col="12" class="mt-2" v-if="landingPage.content.products">
                <div class="cursor-pointer d-inline-block mfe-1 px-1 b-a-1 mt-1" v-for="(pr, index) in landingPage.content.products" :key="index" style="font-size: 10px;border-radius: 3px;" @click="deleteProduct(pr.id)">
                  <FaIcon icon="times" class="text-danger align-middle mfe-1" />
                  {{ pr.name.substring(0, 20)+".." }}
                </div>
              </CCol>
            </CRow>

          </CCol>
          <CCol col="12" sm="7" md="8" class="white-bg py-3 b-l-1">
            <CRow>
              <CCustomInput
                v-model="landingPage.content.name"
                sm="12"
                vid="name"
                :name="$t('store.landing_page.name')"
                rules="required"
                required
              />

              <CCustomInput
                v-model="landingPage.content.title"
                sm="12"
                vid="title"
                :name="$t('store.landing_page.title')"
                rules="required"
                required
              />

              <CCustomTextarea
                v-model="landingPage.content.text"
                rows="5"
                sm="12"
                vid="text"
                :name="$t('store.landing_page.text')"
                rules="required"
                required
              />

              <CCol col="12" class="mt-3">
                <span>حوزه‌های فعالیت</span>
                <CRow>
                  <CCol
                    class="mb-3"
                    col="12"
                    lg="4"
                    md="5"
                    v-for="(field, fIndex) in landingPage.content.fields"
                    :key="fIndex"
                  >
                    <CCard class="h-100">
                      <CCardHeader>
                        <span>{{ field.title }}</span>
                        <span class="float-right">
                          <FaIcon
                            class="cursor-pointer text-info"
                            icon="edit"
                            @click="
                              fieldModal = {
                                item: {
                                  src: field.src,
                                  title: field.title,
                                  custom: field.custom,
                                  index: fIndex,
                                },
                                show: true,
                              }
                            "
                          />
                          <FaIcon
                            class="cursor-pointer mfs-2 text-danger"
                            icon="close"
                            @click="deleteField(fIndex)"
                          />
                        </span>
                      </CCardHeader>
                      <CCardImg
                        style="width: 96px"
                        class="m-auto"
                        :src="field.custom ? field.src : field.src.value"
                      ></CCardImg>
                    </CCard>
                  </CCol>
                  <CCol class="mb-3" col="12" sm="4" md="2">
                    <CCard
                      class="cursor-pointer h-100"
                      @click="
                        fieldModal = {
                          item: {
                            src: '',
                            title: '',
                            custom: false,
                            index: undefined,
                          },
                          show: true,
                        }
                      "
                    >
                      <CCardBody class="d-flex">
                        <FaIcon icon="plus" size="xl" class="m-auto" />
                      </CCardBody>
                    </CCard>
                  </CCol>
                </CRow>
              </CCol>

              <CCol col="12" class="mt-3">
                <span>مزایای همکاری با فروشگاه</span>
                <CRow>
                  <CCol
                    class="mb-3"
                    col="12"
                    lg="4"
                    md="5"
                    v-for="(benefit, bIndex) in landingPage.content.benefits"
                    :key="bIndex"
                  >
                    <CCard class="h-100">
                      <CCardHeader>
                        <span>
                          <FaIcon
                            size="xl"
                            :style="{ color: benefit.bg.color }"
                            :icon="benefit.icon.value"
                          />
                        </span>
                        <span class="float-right">
                          <FaIcon
                            class="cursor-pointer text-info"
                            icon="edit"
                            @click="
                              benefitModal = {
                                item: {
                                  title: benefit.title,
                                  text: benefit.text,
                                  icon: benefit.icon,
                                  bg: benefit.bg,
                                  index: bIndex,
                                },
                                show: true,
                              }
                            "
                          />
                          <FaIcon
                            class="cursor-pointer mfs-2 text-danger"
                            icon="close"
                            @click="deleteBenefit(bIndex)"
                          />
                        </span>
                      </CCardHeader>
                      <CCardBody>
                        <h6>{{ benefit.title }}</h6>
                        <p class="d-block">{{ benefit.text }}</p>
                      </CCardBody>
                    </CCard>
                  </CCol>

                  <CCol
                    class="mb-3"
                    col="12"
                    sm="4"
                    md="2"
                    v-if="landingPage.content.benefits && landingPage.content.benefits.length < 3"
                  >
                    <CCard
                      class="cursor-pointer h-100"
                      @click="
                        benefitModal = {
                          item: {
                            title: '',
                            text: '',
                            icon: '',
                            bg: '',
                            index: undefined,
                          },
                          show: true,
                        }
                      "
                    >
                      <CCardBody class="d-flex">
                        <FaIcon icon="plus" size="xl" class="m-auto" />
                      </CCardBody>
                    </CCard>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>

            <CRow>
              <CCol col="12" class="mt-5">
                <span>محتوای اختصاصی</span>
                <ckeditor
                  :editor="editor"
                  v-model="landingPage.content.custom_content"
                  :config="editorConfig"
                ></ckeditor>
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </Form>
    </ValidationObserver>

    <CModal :show.sync="fieldModal.show">
      <template #header-wrapper>
        <div></div>
      </template>
      <ValidationObserver ref="fieldForm" v-slot="{ invalid }">
        <span
          v-if="!fieldModal.item.custom"
          @click="(fieldModal.item.src = ''), (fieldModal.item.custom = true)"
          >تصویر دلخواه</span
        >
        <span
          v-if="fieldModal.item.custom"
          @click="(fieldModal.item.src = ''), (fieldModal.item.custom = false)"
          >انتخاب از لیست</span
        >
        <CCustomSearchableInput
          v-if="!fieldModal.item.custom"
          :key="fieldModal.item.index"
          v-model="fieldModal.item.src"
          col="12"
          vid="src"
          :name="$t('store.landing_page.fields.src')"
          required
          rules="required"
          :items="fieldImages"
          :limit="100"
        >
          <template #customItem="{ item }">
            <span class="d-block py-1">
              <img :src="item.value.replace('/96/', '/24/')" />
              {{ item.label }}
            </span>
          </template>
        </CCustomSearchableInput>
        <CCustomInput
          v-else
          v-model="fieldModal.item.src"
          col="12"
          vid="src"
          :name="$t('store.landing_page.fields.src')"
          rules="required"
          required
          ltr
        />

        <CCustomInput
          v-model="fieldModal.item.title"
          col="12"
          vid="title"
          :name="$t('store.landing_page.fields.title')"
          rules="required"
          required
        />

        <CCol col="12" class="modal-footer">
          <CButton
            @click="
              fieldModal = {
                item: { src: '', title: '', index: undefined },
                show: false,
              }
            "
            color="secondary"
            >{{ $t("cancel") }}</CButton
          >
          <CButton :disabled="invalid" @click="addField" color="primary">{{
            $t("submit")
          }}</CButton>
        </CCol>
      </ValidationObserver>

      <template #footer-wrapper>
        <div></div>
      </template>
    </CModal>

    <CModal :show.sync="benefitModal.show">
      <template #header-wrapper>
        <div></div>
      </template>
      <ValidationObserver ref="benefitForm" v-slot="{ invalid }">
        <CCustomSearchableInput
          :key="benefitModal.item.index"
          v-model="benefitModal.item.icon"
          col="12"
          vid="icon"
          :name="$t('store.landing_page.benefits.icon')"
          required
          rules="required"
          :items="benefitIcons"
        >
          <template #customItem="{ item }">
            <span class="d-block py-1">
              <FaIcon :icon="item.value" />
              {{ item.label }}
            </span>
          </template>
        </CCustomSearchableInput>

        <CCustomSearchableInput
          :key="benefitModal.item.index"
          v-model="benefitModal.item.bg"
          col="12"
          vid="bg"
          :name="$t('store.landing_page.benefits.bg')"
          required
          rules="required"
          :items="benefitBgs"
        >
          <template #customItem="{ item }">
            <span class="d-block py-1">
              <span
                :style="{
                  width: '15px',
                  height: '15px',
                  display: 'inline-block',
                  verticalAlign: 'middle',
                  backgroundColor: item.color,
                }"
              ></span>
              <span class="mfs-1">{{ item.label }}</span>
            </span>
          </template>
        </CCustomSearchableInput>

        <CCustomInput
          v-model="benefitModal.item.title"
          col="12"
          vid="title"
          :name="$t('store.landing_page.benefits.title')"
          rules="required"
          required
        />

        <CCustomInput
          v-model="benefitModal.item.text"
          col="12"
          vid="text"
          :name="$t('store.landing_page.benefits.text')"
          rules="required"
          required
        />

        <CCol col="12" class="modal-footer">
          <CButton
            @click="
              benefitModal = benefitModal = {
                item: {
                  title: '',
                  text: '',
                  icon: '',
                  bg: '',
                  index: undefined,
                },
                show: false,
              }
            "
            color="secondary"
            >{{ $t("cancel") }}</CButton
          >
          <CButton :disabled="invalid" @click="addBenefit" color="primary">{{
            $t("submit")
          }}</CButton>
        </CCol>
      </ValidationObserver>

      <template #footer-wrapper>
        <div></div>
      </template>
    </CModal>
  </CContainer>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { storeService, productService } from "@/services/api";
import { fieldImages, benefitBgs, benefitIcons } from "./partials/landing";
import CKEditor from '@ckeditor/ckeditor5-vue2';
import Editor from '@affili/ckeditor5-custom-build/build/ckeditor';
import CCustomInputCheckbox from '@/components/form/CCustomInputCheckbox'

export default {
  name: "LandingPage",

  components: {
    CCustomInputCheckbox,
    ckeditor: CKEditor.component,
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.getLandingPage();
      vm.fetchProducts();
    });
  },

  data() {
    return {
      storeId: this.$route.params.id,
      slug: "",
      myInterval: '',
      productItem: {},
      products: [],
      landingPage: {
        content: {
          name: "",
          title: "",
          category: "",
          text: "",
          featured_image: "",
          fields: [],
          products: [],
          benefits: [],
          video: "",
          custom_content: "",
        },
        slug: '',
        status: 0,
        indexable: 0,
      },
      fieldModal: {
        item: {},
        show: false,
      },
      benefitModal: {
        item: {},
        show: false,
      },
      fieldImages,
      benefitBgs,
      benefitIcons,
      editor: Editor,
      editorConfig: {
        toolbar: {
          items: [
            'heading',
            'fontSize',
            '|',
            'bold',
            'italic',
            'link',
            'bulletedList',
            'numberedList',
            '|',
            'outdent',
            'indent',
            '|',
            'undo',
            'redo'
          ]
        },
        link: {
          decorators: {
            isExternal: {
              mode: 'manual',
              label: 'Open in a new tab',
              attributes: {
                target: '_blank',
              }
            },
          }
        },
        language: 'fa',
      },
    };
  },

  computed: {
    ...mapGetters({
      showLoading: "loadingComponent/show",
    }),
    productId: {
      get() {
        return this.productItem ? this.productItem.name : ''
      },
      set(val) {
        clearInterval(this.myInterval)

        if (val.id) {
          this.productItem = {}
          this.productItem.id = val.id
          this.productItem.name = val.name

          return
        }

        if (val.label) {
          this.myInterval = setTimeout(() => {
            this.fetchProducts({
              name: val.label
            })
          }, 500)

          return
        }
      }
    }
  },

  methods: {
    ...mapActions({
      setMsg: "messageComponent/setMsg",
      resetMsg: "messageComponent/resetMsg",
      setShowLoading: "loadingComponent/setShowLoading",
    }),
    getLandingPage() {
      storeService.getLandingPage(this.storeId).then((res) => {
        let result = res.data.data;

        this.landingPage = result;

        if (result.content) {
          this.landingPage.content = typeof result.content === "object" ? result.content : JSON.parse(result.content);
        } else {
          this.landingPage.content = {
            name: "",
            title: "",
            category: "",
            text: "",
            featured_image: "",
            fields: [],
            products: [],
            benefits: [],
            video: "",
            custom_content: "",
          }
        }
      });
    },
    fetchProducts(params = {}) {
      const data = {
        in_stock: 1,
        store_id: this.storeId,
        just: ['id', 'name'],
        name: params.name
      }

      productService.fetch(data).then(res => {
        this.products = res.data.data
      })
    },

    addProduct() {
      if (!this.productItem || !this.productItem.id) {
        return
      }

      if (!this.landingPage.content.products) {
        this.landingPage.content.products = []
      }

      if (!this.landingPage.content.products.find(pro => pro.id === this.productItem.id)) {
        this.landingPage.content.products.push(this.productItem);
      }

      this.productItem = null;
    },
    deleteProduct(id) {
      this.landingPage.content.products = this.landingPage.content.products.filter(
        (product, i) => product.id !== id
      );
    },

    addField() {
      if (!this.landingPage.content.fields) {
        this.landingPage.content.fields = []
      }

      if (this.landingPage.content.fields[this.fieldModal.item.index]) {
        this.landingPage.content.fields[this.fieldModal.item.index] = this.fieldModal.item;
      } else {
        this.landingPage.content.fields.push(this.fieldModal.item);
      }
      this.fieldModal = {
        item: { src: "", title: "", custom: false, index: 0 },
        show: false,
      };
      this.$refs.fieldForm.reset();
    },
    deleteField(index) {
      this.landingPage.content.fields = this.landingPage.content.fields.filter(
        (field, i) => i !== index
      );
    },
    addBenefit() {
      if (!this.landingPage.content.benefits) {
        this.landingPage.content.benefits = []
      }

      if (this.landingPage.content.benefits[this.benefitModal.item.index]) {
        this.landingPage.content.benefits[this.benefitModal.item.index] =
          this.benefitModal.item;
      } else {
        this.landingPage.content.benefits.push(this.benefitModal.item);
      }
      this.benefitModal = {
        item: { title: "", text: "", icon: "", bg: "", index: undefined },
        show: false,
      };
      this.$refs.benefitForm.reset();
    },
    deleteBenefit(index) {
      this.landingPage.content.benefits = this.landingPage.content.benefits.filter(
        (benefit, i) => i !== index
      );
    },
    submit() {
      this.setShowLoading();
      this.resetMsg();

      storeService.modifyLandingPage(this.landingPage, this.storeId).then((res) => {
        this.setShowLoading(false);
        this.setMsg({
          content: this.$t("tags.modifyLandingPage"),
          type: "success",
        });
      });
    },
  },
};
</script>

<style>
.ck.ck-content.ck-editor__editable {
  min-height: 200px;
}
</style>

<style scoped lang="scss">
::v-deep .custom-searchable-input .form-group {
  margin-bottom: 0!important;
}
</style>